import * as React from 'react';
import createSvgImage from './createSvgImage';

// TODO lucasOliveira use `createSvgIcon`
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconLumiOutlinedCustom = createSvgImage( /*#__PURE__*/_jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_428_1385)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12.6667 6.00008L13.5 4.16675L15.3334 3.33341L13.5 2.50008L12.6667 0.666748L11.8334 2.50008L10 3.33341L11.8334 4.16675L12.6667 6.00008Z",
      fill: "url(#paint0_linear_428_1385)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.6667 10.0001L11.8334 11.8334L10 12.6667L11.8334 13.5001L12.6667 15.3334L13.5 13.5001L15.3334 12.6667L13.5 11.8334L12.6667 10.0001Z",
      fill: "url(#paint1_linear_428_1385)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.66669 6.33341L6.00002 2.66675L4.33335 6.33341L0.666687 8.00008L4.33335 9.66675L6.00002 13.3334L7.66669 9.66675L11.3334 8.00008L7.66669 6.33341ZM6.66002 8.66008L6.00002 10.1134L5.34002 8.66008L3.88669 8.00008L5.34002 7.34008L6.00002 5.88675L6.66002 7.34008L8.11335 8.00008L6.66002 8.66008Z",
      fill: "url(#paint2_linear_428_1385)"
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_428_1385",
      x1: "0.666687",
      y1: "0.666748",
      x2: "15.8578",
      y2: "0.892095",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.515",
        stopColor: "#D62EA9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#F36C23"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint1_linear_428_1385",
      x1: "0.666687",
      y1: "0.666748",
      x2: "15.8578",
      y2: "0.892095",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.515",
        stopColor: "#D62EA9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#F36C23"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint2_linear_428_1385",
      x1: "0.666687",
      y1: "0.666748",
      x2: "15.8578",
      y2: "0.892095",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.515",
        stopColor: "#D62EA9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#F36C23"
      })]
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_428_1385",
      children: /*#__PURE__*/_jsx("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    })]
  })]
}), 'IconLumiOutlinedCustom', 16, 16);

// TODO lucasOliveira use `createSvgIcon`
export var IconLumiCustom = createSvgImage( /*#__PURE__*/_jsxs("g", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  children: [/*#__PURE__*/_jsx("rect", {
    width: "38",
    height: "38",
    x: "1",
    y: "1",
    fill: "#fff",
    rx: "19"
  }), /*#__PURE__*/_jsx("rect", {
    width: "38",
    height: "38",
    x: "1",
    y: "1",
    stroke: "url(#a)",
    strokeWidth: "2",
    rx: "19"
  }), /*#__PURE__*/_jsxs("g", {
    clipPath: "url(#b)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "url(#c)",
      d: "m25.833 17.5 1.042-2.292 2.292-1.041-2.292-1.042-1.042-2.292-1.041 2.292-2.292 1.042 2.292 1.041 1.041 2.292Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#d)",
      d: "m25.833 22.5-1.041 2.292-2.292 1.041 2.292 1.042 1.041 2.292 1.042-2.292 2.292-1.042-2.292-1.041-1.042-2.292Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "url(#e)",
      d: "M19.583 17.917 17.5 13.333l-2.083 4.584L10.833 20l4.584 2.083 2.083 4.584 2.083-4.584L24.167 20l-4.584-2.083Zm-1.258 2.908-.825 1.817-.825-1.817L14.858 20l1.817-.825.825-1.817.825 1.817 1.817.825-1.817.825Z"
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "a",
      x1: "0",
      x2: "41.43",
      y1: "0",
      y2: ".615",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D62EA9"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "c",
      x1: "10.833",
      x2: "29.822",
      y1: "10.833",
      y2: "11.115",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D62EA9"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "d",
      x1: "10.833",
      x2: "29.822",
      y1: "10.833",
      y2: "11.115",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D62EA9"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "e",
      x1: "10.833",
      x2: "29.822",
      y1: "10.833",
      y2: "11.115",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#7F14EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D62EA9"
      })]
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "b",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M10 10h20v20H10z"
      })
    })]
  })]
}), 'IconLumiCustom', 40, 40);